import { FrameHealthTab } from 'features/Health/components/FrameHealthTabs/types/frameHealthTab';

export const frameHealthTabValues: FrameHealthTab[] = [
  {
    label: 'Environment',
    value: '1',
    frameHealthDimension: 'environment',
  },
  {
    label: 'Format Size',
    value: '2',
    frameHealthDimension: 'formatSize',
  },
  {
    label: 'Publisher',
    value: '3',
    frameHealthDimension: 'publisher',
  },
  {
    label: 'Resolution',
    value: '4',
    frameHealthDimension: 'resolution',
  },
];
